export enum ViewabilityEventType {
    ViewStart = "onViewableStart",
    ViewStop = "onViewableStop",
    ViewChange = "onViewableChange",
    ViewComplete = "onViewableComplete",
    ViewUnmeasurable = "onUnmeasurable"
}
